import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export const useTrackBlogView = (slug) => {
  useEffect(() => {
    if (!slug) return;

    const track = async () => {
      // Use the SECURITY DEFINER function to increment
      const { error } = await supabase.rpc("increment_visit", { page_slug: slug });
      if (error) {
        console.error("❌ increment error:", error);
      } else {
        console.log("✅ View tracked for:", slug);
      }
    };

    track();
  }, [slug]);
};

export const useBlogViews = (slug) => {
  const [views, setViews] = useState(null);

  useEffect(() => {
    if (!slug) return;

    const fetchViews = async () => {
      const { data, error } = await supabase
        .from("blog_visit_counts")
        .select("total_visits")
        .eq("slug", slug)
        .single();

      if (error) {
        setViews(0);
      } else {
        setViews(data?.total_visits ?? 0);
      }
    };

    fetchViews();
  }, [slug]);

  return views;
};